export default __webpack_public_path__ + "images/0x09bc4e0d864854c6afb6eb9a9cdf58ac190d0df9.png";